export { default as ProductTitle } from './ProductTitle'



// WEBPACK FOOTER //
// ./src/components/productTitle/index.js